import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: React.StrictMode removed to prevent conflicts with Daily.co video iframe
// StrictMode causes double-renders which conflict with Daily's direct DOM manipulation
root.render(
  <App />
);
